import React from 'react';
export function DefaultIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "30",
    r: "30",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2735 22.2119C16.9133 22.2119 15 24.1252 15 26.4854V32.3615C15 34.7217 16.9133 36.635 19.2735 36.635H22.2115V43.8465H25.8173V36.635H29.4231V22.2119H19.2735Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4231 22.2115L43.1226 15.3618C43.455 15.1956 43.8462 15.4373 43.8462 15.809V43.0371C43.8462 43.4088 43.455 43.6506 43.1226 43.4843L29.4231 36.6346V22.2115Z",
    fill: "#D3D3D3"
  }));
}